// import configUrl from '../config/configUrl'
let prefix = process.env.VUE_APP_PREFIX;
export default {
  isTokenExpired(){
    let expriedAtTime = localStorage.getItem(prefix+'expriredAt');
    let nowTime = new Date().getTime();
    if(!expriedAtTime || expriedAtTime === "undefined"){
      return true
    }
    // console.log('time',expriedAtTime - nowTime)
    return (expriedAtTime - nowTime < 1000*60*2)
  },
  setExpiredAt(d){
      // let t = new Date().getTime();
      // let ex = t + d;
      console.log('ex',d)
      localStorage.setItem(prefix+"expriredAt",d)
  },
  objToUrl(obj){
    let arr = Object.keys(obj);
    let str = ""
    arr.forEach(item => {
      str += "&" + item + "=" + obj[item]
    })
    return str.slice(1)
  },
  updateSessionId(){
    let lsessionId = localStorage.getItem('burrySessionId')
    if(lsessionId){
      return lsessionId
    }
    let sessionId = this.generateGuid()
    localStorage.setItem('burrySessionId',sessionId)
    return sessionId
  },
  generateGuid(){
    return localStorage.getItem('burrySessionId')
    // function s4() {
    //   return Math.floor((1 + Math.random()) * 0x10000)
    //     .toString(16)
    //     .substring(1);
    // }
    // const PRE = 's_';
    // return PRE + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  },
  getQueryVariable(variable){
    var query = ""
    if(window.location.href.indexOf("?") === -1){
      return ""
    }
    if(window.location.href.indexOf("/#/?") > -1){
      query = window.location.href.split("/#/?")[1];
    }else{
      query = window.location.href.split("?")[1];
    }
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){return pair[1];}
    }
    return "";
  },
  getIndexRoute(){
    // let indexRoute = ""
    if(window.location.href.indexOf("/#/?") > -1){
      return ''
    }else{
      let routeStr = window.location.href.split("/#/")[1] || "";
      let idx = routeStr.indexOf("?")
      return idx > -1 ? routeStr.substring(0,idx) : ""
    }
  }
}
// export default utils